import { startMeasurement, trackUsage } from './metrics';
import { bindCommerce } from './commerce';

startMeasurement();
bindCommerce();
document.querySelector('[data-track="kit-preview-requested"]')?.addEventListener('click', () => trackUsage('kit-preview-requested'));
